import { Edit } from '@refinedev/antd'
import { useForm } from '@refinedev/antd'
import { CuisineForm } from './Form'
import { ICuisine } from 'interfaces/catering'

export const CuisineEdit: React.FC = () => {
  const useFormResult = useForm<ICuisine>()
  return (
    <Edit saveButtonProps={{ htmlType: 'submit', form: 'cuisine-form' }}>
      <CuisineForm useFormProps={useFormResult} />
    </Edit>
  )
}
